import { render, staticRenderFns } from "./EditRepairSetting.vue?vue&type=template&id=1b1b60e0"
import script from "./EditRepairSetting.vue?vue&type=script&lang=js"
export * from "./EditRepairSetting.vue?vue&type=script&lang=js"
import style0 from "./EditRepairSetting.vue?vue&type=style&index=0&id=1b1b60e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports